import {
  StoreImageTypeSchema,
  type StoreImageType as GeneratedStoreImageType
} from '~/services/api/generated'

// Mirrors backend App\Enums\Store\StoreImageType

export type StoreImageType = GeneratedStoreImageType

export const StoreImageType = {
  COVER: StoreImageTypeSchema.enum.cover,
  LOGO: StoreImageTypeSchema.enum.logo
} satisfies Record<string, GeneratedStoreImageType>

export const StoreImageTypeValues: readonly GeneratedStoreImageType[] = [
  StoreImageTypeSchema.enum.cover,
  StoreImageTypeSchema.enum.logo
]
